<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">-->

<div class="page-container custom-page-background position-absolute">

  <div class="forgot-password-page">

    <form #f="ngForm" (submit)="formSubmit(f)" class="forgot-password-form">
      <div class="forgot-password-form-container">
        <div class="header">
          <div class="hass-logo" style=" max-width: 270px; margin: 0 auto;">
            <img src="/src/assets/images/HASSLogo.png" />
          </div>

          <p>where <strong>excellent hearing</strong> begins</p>
        </div>

        <div class="sub-header">
          <h2>Password Reset Request</h2>
          <p>Enter Cell Phone Number to reset password</p>
        </div>


        <div class="form">

          <!--<div class="form-group">
            <label>Email Address</label>
            <input type="text" class="form-control form-control-lg" [(ngModel)]="request.UserName" #UserNameCtrl="ngModel" name="UserName" required />
            <div *ngIf="submitted && UserNameCtrl.invalid" class="invalid-feedback">
              <div *ngIf="UserNameCtrl.errors?.['required']">
                <i class="fas fa-exclamation-circle"></i> Username is required
              </div>
            </div>
          </div>-->
          <div class="form-group">
            <label>Cell Phone Number:</label>
            <input type="tel" class="form-control form-control-lg" [(ngModel)]="request.UserCellphone" #UserCellphoneCtrl="ngModel" name="UserCellphone" required />
            <div *ngIf="submitted && UserCellphoneCtrl.invalid" class="invalid-feedback">
              <div *ngIf="UserCellphoneCtrl.errors?.['required']">
                <i class="fas fa-exclamation-circle"></i> Cellphone Number is required
              </div>
            </div>
          </div>

          <div class="button-group" style="width: 100%">
            <button type="button" (click)="CancelRequest()" class="custom-btn">Cancel</button>
            <button type="submit" class="custom-btn">Reset Password</button>
          </div>

        </div>

        <div class="form-footer">
          <div>
            <p><small>Copy &copy;2024 H.A.S.S Ear Institute</small></p>
            <small><a style="margin-right: 10px">Term of Service</a> | <a style="margin-left: 10px">Privacy Policy</a></small>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
